// extracted by mini-css-extract-plugin
module.exports = {"container":"Footer_container__st7Zp","copyright":"Footer_copyright__2OWH4","fdic":"Footer_fdic__14EzF"};